(function () {
  function buildNav(section) {
    var nav = section.querySelector('.custom-faq-tabs__nav');
    var panels = section.querySelectorAll('.custom-faq-panel');
    if (!nav || !panels.length) return;

    nav.innerHTML = '';
    var buttons = [];

    panels.forEach(function (panel, index) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-faq-tab';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-controls', panel.id);
      btn.id = panel.id + '-tab';
      panel.setAttribute('aria-labelledby', btn.id);
      btn.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      btn.tabIndex = index === 0 ? 0 : -1;

      // Màu từ data-*
      btn.style.setProperty('--faq-btn-bg', panel.dataset.bg || '');
      btn.style.setProperty('--faq-btn-text', panel.dataset.text || '');
      btn.style.setProperty('--faq-btn-bg-active', panel.dataset.bgActive || '');
      btn.style.setProperty('--faq-btn-text-active', panel.dataset.textActive || '');

      // Icon (clone từ node ẩn trong panel)
      var iconSrc = panel.querySelector('[data-faq-icon]');
      if (iconSrc && iconSrc.innerHTML.trim()) {
        var iconWrap = document.createElement('span');
        iconWrap.className = 'custom-faq-tab__icon';
        iconWrap.setAttribute('aria-hidden', 'true');
        iconWrap.innerHTML = iconSrc.innerHTML;
        btn.appendChild(iconWrap);
      }

      var label = document.createElement('span');
      label.className = 'custom-faq-tab__label';
      label.textContent = panel.dataset.label || '';
      btn.appendChild(label);

      panel.classList.toggle('is-active', index === 0);

      btn.addEventListener('click', function () {
        activate(buttons, panels, index);
      });

      buttons.push(btn);
      nav.appendChild(btn);
    });

    // Đồng bộ banner (tiêu đề + màu nền) theo tab active đầu tiên khi load
    activate(buttons, panels, 0);

    // Điều hướng bàn phím (roving tabindex) — bind 1 lần, đọc DOM trực tiếp khi sự kiện xảy ra
    if (nav.dataset.keysBound !== '1') {
      nav.dataset.keysBound = '1';
      nav.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var btns = Array.prototype.slice.call(nav.querySelectorAll('.custom-faq-tab'));
        var pnls = Array.prototype.slice.call(section.querySelectorAll('.custom-faq-panel'));
        if (!btns.length) return;
        var current = btns.findIndex(function (b) { return b.getAttribute('aria-selected') === 'true'; });
        var next = e.key === 'ArrowRight' ? (current + 1) % btns.length : (current - 1 + btns.length) % btns.length;
        e.preventDefault();
        activate(btns, pnls, next);
        btns[next].focus();
      });
    }
  }

  function activate(buttons, panels, index) {
    buttons.forEach(function (b, i) {
      var on = i === index;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function (p, i) {
      p.classList.toggle('is-active', i === index);
    });

    // Banner đổi theo tab active: tiêu đề = tên category, nền = màu button
    var active = panels[index];
    if (!active) return;
    var section = active.closest('.custom-faq-tabs');
    var banner = section && section.querySelector('.custom-faq-banner');
    if (!banner) return;
    var heading = banner.querySelector('.custom-faq-banner__heading');
    var label = heading && (heading.querySelector('[data-faq-banner-label]') || heading);
    if (label && active.dataset.label) label.textContent = active.dataset.label;
    if (active.dataset.bg) banner.style.setProperty('--faq-banner-bg', active.dataset.bg);
    if (active.dataset.text) banner.style.setProperty('--faq-banner-text', active.dataset.text);
  }

  function initFaqTabs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('.custom-faq-tabs');
    sections.forEach(function (section) {
      // Đồng bộ nền cream xuống body để liền mạch tới footer (curve footer trong suốt)
      var bg = getComputedStyle(section).getPropertyValue('--faq-section-bg').trim();
      if (bg) {
        document.body.style.setProperty('--faq-page-bg', bg);
        document.body.classList.add('custom-faq-cream');
      }
      if (section.dataset.faqInit === '1') return;
      section.dataset.faqInit = '1';
      buildNav(section);
    });
  }

  // Init timing: theme này chạy script sau DOMContentLoaded
  if (document.readyState !== 'loading') {
    initFaqTabs(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { initFaqTabs(document); });
  }

  // Theme Editor: rebuild khi section load lại
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.custom-faq-tabs')) {
      e.target.querySelectorAll('.custom-faq-tabs').forEach(function (s) { s.dataset.faqInit = '0'; });
      initFaqTabs(e.target);
    }
  });

  // Khi chọn block category trong editor → active panel tương ứng
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest('.custom-faq-panel');
    if (!panel) return;
    var section = panel.closest('.custom-faq-tabs');
    if (!section) return;
    var panels = Array.prototype.slice.call(section.querySelectorAll('.custom-faq-panel'));
    var idx = panels.indexOf(panel);
    var buttons = section.querySelectorAll('.custom-faq-tab');
    if (idx > -1 && buttons.length) {
      activate(Array.prototype.slice.call(buttons), panels, idx);
    }
  });
})();